<template>
  <div>
    <h3 v-if="titleWidget" class="text-center title-widget-package">{{titleWidget}}</h3>
    <ae-package-list
      v-if="canRender"
      :class="{ 'aedw-package-list-default-grid': useDefaultGridCols }"
      :posId.prop="posId"
      :config.prop="config"
      :template.prop="templateName"
      :params.prop="params"
      :disableGetPackagesOnRender.prop="disableGetPackagesOnRender"
      :show_in_carroussel_mobile="show_in_carroussel_mobile"
      :show_in_carroussel_desktop="show_in_carroussel_desktop"
      :use_location_unit_selector="use_location_unit_selector"
      :location_unit_selector_params.prop="location_unit_selector_params"
      :use_multi_widgets="use_multi_widgets"
      :multi_widgets_params.prop="multi_widgets_params"
      :paramsFilterRequestPOS.prop="paramsFilterRequestPOS"
      :bonusStripColor.prop="bonusStripColor"
      :showinstallmentsLabel.prop="showinstallmentsLabel"
      :showIconsWithInformation.prop="showIconsWithInformation"
      @toCheckout="toCheckout"
    ></ae-package-list>
  </div>
</template>

<style lang="scss">
.VueCarousel{
  width: 100vw;
}
.VueCarousel .ae-package-default{
  width: 100% !important;
}
.aedw-package-list-default-grid {
  .ae-package-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-items: center;
    align-items: center;
    gap: 24px;
  }

  @media only screen and (max-width: 1080px) {
    .ae-package-list {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media only screen and (max-width: 600px) {
    .ae-package-list {
      grid-template-columns: 1fr;
    }
  }
}
</style>

<script>
import modals from "../../../components/modals";

export default {
  props: [
    "useCustomTemplate",
    "templateName",
    "params",
    "posId",
    "config",
    "useDefaultGridCols",
    "disableGetPackagesOnRender",
    "show_in_carroussel_mobile",
    "show_in_carroussel_desktop",
    "titleWidget",
    "use_location_unit_selector",
    "location_unit_selector_params",
    "use_multi_widgets",
    "multi_widgets_params",
    "paramsFilterRequestPOS",
    "bonusStripColor",
    "showinstallmentsLabel",
    "showIconsWithInformation"
  ],

  data() {
    return {
      canRender: false
    };
  },

  created() {
    setTimeout(() => {
      this.canRender = true;
    });
  },

  mounted(){
    
    let time = 0
    if(this.show_in_carroussel_mobile || this.show_in_carroussel_desktop){
      const interval = setInterval(()=>{
          if(document.querySelectorAll('.VueCarousel').length){
              clearInterval(interval)
              document.querySelectorAll('.VueCarousel').forEach(item=>{
                if(document.querySelectorAll('.container').length != 0){
                  item.style = 'max-width:'+(document.querySelector('.container').offsetWidth - 30) +'px !important';
                }   
              })
          }
          time ++
          if(time >= 20) clearInterval(interval)
      },500)
    }
    
  },

  methods: {
    toCheckout() {
      modals.showCheckoutModal();
    },
  },
};
</script>